import { lazy } from "react";

const create = lazy(() => import("./Create").then(m => ({ default: m.PortalServiceProviderFirmCreate })));

export default { create };
